import axios from 'axios';
import { APIBaseURL } from '../constants/ApiEndPoints';

const SESSION_NOTES_API = `${APIBaseURL}/admin/session-notes`;

export const getSessionNotes = async (filters?: any) => {
  try {
    const response = await axios.get(SESSION_NOTES_API, { params: filters });
    return response.data;
  } catch (error: any) {
    return error.response?.data || { success: false, message: 'Failed to fetch session notes' };
  }
};

export const getSessionNoteById = async (id: string) => {
  try {
    const response = await axios.get(`${SESSION_NOTES_API}/${id}/students`);
    return response.data;
  } catch (error: any) {
    return error.response?.data || { success: false, message: 'Failed to fetch session note' };
  }
};

export const createSessionNote = async (data: any) => {
  try {
    const response = await axios.post(SESSION_NOTES_API + '/create', data);
    return response.data;
  } catch (error: any) {
    return error.response?.data || { success: false, message: 'Failed to create session note' };
  }
};

export const updateSessionNote = async (id: string, data: any) => {
  try {
    const response = await axios.put(`${SESSION_NOTES_API}/${id}`, data);
    return response.data;
  } catch (error: any) {
    return error.response?.data || { success: false, message: 'Failed to update session note' };
  }
};

export const reviewSessionNote = async (id: string, data: { action: 'approve' | 'reject'; comments?: string }) => {
  try {
    const response = await axios.post(`${SESSION_NOTES_API}/${id}/review`, data);
    return response.data;
  } catch (error: any) {
    return error.response?.data || { success: false, message: 'Failed to process review' };
  }
};

export const getReviewSetting = async () => {
  try {
    const response = await axios.get(`${APIBaseURL}/settings/session-notes-review`);
    return response.data;
  } catch (error: any) {
    return error.response?.data || { success: false, message: 'Failed to fetch review setting' };
  }
};

export const bulkReviewSessionNotes = async (data: {
  approve: Array<{ session_note_id: number; student_ids: number[] }>;
  reject: Array<{ session_note_id: number; student_ids: number[]; comments: string }>;
}) => {
  try {
    const response = await axios.post(`${SESSION_NOTES_API}/bulk-review`, data);
    return response.data;
  } catch (error: any) {
    return error.response?.data || { success: false, message: 'Failed to process bulk review' };
  }
};

export const getSessionNoteDetails = async (filters: {
  sessionDate?: string;
  franchiseId: number;
  centreId?: number;
  subjectId?: number;
  studentId?: number;
  attended?: string;
  homeworkStatus?: string;
  sessionStatus?: string;
  limit?: number;
}) => {
  try {
    const params: any = {
      sessionDate: filters.sessionDate || '',
      franchiseId: filters.franchiseId,
      centreId: filters.centreId || '',
      subjectId: filters.subjectId || '',
      studentId: filters.studentId || '',
      attended: filters.attended || '',
      homeworkStatus: filters.homeworkStatus || '',
      sessionStatus: filters.sessionStatus || '',
      limit: filters.limit || ''
    };
    
    const response = await axios.get(`${SESSION_NOTES_API}/details`, { params });
    return response.data;
  } catch (error: any) {
    return error.response?.data || { success: false, message: 'Failed to fetch session note details' };
  }
};

export const updateSessionNoteByDetails = async (data: any) => {
  try {
    const response = await axios.post(`${SESSION_NOTES_API}/update`, data);
    return response.data;
  } catch (error: any) {
    return error.response?.data || { success: false, message: 'Failed to update session note' };
  }
};

export const bulkUpdateSessionNoteStatus = async (data: {
  session_note_publish_ids: number[];
  session_note_draft_ids: number[];
  review_comment: string;
}) => {
  try {
    const response = await axios.put(`${SESSION_NOTES_API}/status/bulk`, data);
    return response.data;
  } catch (error: any) {
    return error.response?.data || { success: false, message: 'Failed to update session note status' };
  }
};

export const getSessionNotesByStudent = async (student_id: number, params: {
  page?: number;
  perPage?: number;
  subjectId?: string;
  fromDate?: string;
  toDate?: string;
  attended?: string;
  homeworkStatus?: string;
} = {}) => {
  try {
    const response = await axios.get(`${APIBaseURL}/admin/session-notes/by-student/${student_id}`, { params });
    return response.data;
  } catch (error: any) {
    return error.response?.data || { success: false, message: 'Failed to fetch session notes' };
  }
};
